import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import * as React from 'react';
var prefix = 'urn';
var namespace = 'event';
var owner = 'view-engine';
export var viewEngineEvents = {
  createBlock: "".concat(prefix, ":").concat(namespace, ":").concat(owner, ":create-block"),
  replaceBlockParameters: "".concat(prefix, ":").concat(namespace, ":").concat(owner, ":replace-block-parameters"),
  deleteBlock: "".concat(prefix, ":").concat(namespace, ":").concat(owner, ":delete-block"),
  createZone: "".concat(prefix, ":").concat(namespace, ":").concat(owner, ":create-zone"),
  replaceZoneParameters: "".concat(prefix, ":").concat(namespace, ":").concat(owner, ":replace-zone-parameters"),
  deleteZone: "".concat(prefix, ":").concat(namespace, ":").concat(owner, ":delete-zone")
};
export function useViewEvents(props) {
  var piletApi = props.piletApi,
    viewDataProvider = props.viewDataProvider,
    refetchViews = props.refetchViews;
  var handleCreateBlockEvent = React.useCallback(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(eventParams) {
      var _eventParams$addBlock;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return viewDataProvider.createBlock(eventParams);
          case 2:
            refetchViews((_eventParams$addBlock = eventParams.addBlockToView) === null || _eventParams$addBlock === void 0 ? void 0 : _eventParams$addBlock.zoneRID);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [refetchViews, viewDataProvider]);
  var handleReplaceBlockParametersEvent = React.useCallback(/*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(eventParams) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return viewDataProvider.replaceBlockParameters(eventParams);
          case 2:
            refetchViews(eventParams.encodedBlockRID);
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [refetchViews, viewDataProvider]);
  var handleDeleteBlockEvent = React.useCallback(/*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(eventParams) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return viewDataProvider.deleteBlock(eventParams);
          case 2:
            refetchViews(eventParams.encodedBlockRID);
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }(), [refetchViews, viewDataProvider]);
  var handleCreateZoneEvent = React.useCallback(/*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(eventParams) {
      var _eventParams$addZoneT;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return viewDataProvider.createZone(eventParams);
          case 2:
            refetchViews((_eventParams$addZoneT = eventParams.addZoneToView) === null || _eventParams$addZoneT === void 0 ? void 0 : _eventParams$addZoneT.blockRID);
          case 3:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }(), [refetchViews, viewDataProvider]);
  var handleReplaceZoneParametersEvent = React.useCallback(/*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(eventParams) {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return viewDataProvider.replaceZoneParameters(eventParams);
          case 2:
            refetchViews(eventParams.encodedZoneRID);
          case 3:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }(), [refetchViews, viewDataProvider]);
  var handleDeleteZoneEvent = React.useCallback(/*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(eventParams) {
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return viewDataProvider.deleteZone(eventParams);
          case 2:
            refetchViews(eventParams.encodedZoneRID);
          case 3:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function (_x6) {
      return _ref6.apply(this, arguments);
    };
  }(), [refetchViews, viewDataProvider]);
  React.useEffect(function () {
    piletApi.on(viewEngineEvents.createBlock, handleCreateBlockEvent);
    piletApi.on(viewEngineEvents.replaceBlockParameters, handleReplaceBlockParametersEvent);
    piletApi.on(viewEngineEvents.deleteBlock, handleDeleteBlockEvent);
    piletApi.on(viewEngineEvents.createZone, handleCreateZoneEvent);
    piletApi.on(viewEngineEvents.replaceZoneParameters, handleReplaceZoneParametersEvent);
    piletApi.on(viewEngineEvents.deleteZone, handleDeleteZoneEvent);
    return function () {
      piletApi.off(viewEngineEvents.createBlock, handleCreateBlockEvent);
      piletApi.off(viewEngineEvents.replaceBlockParameters, handleReplaceBlockParametersEvent);
      piletApi.off(viewEngineEvents.deleteBlock, handleDeleteBlockEvent);
      piletApi.off(viewEngineEvents.createZone, handleCreateZoneEvent);
      piletApi.off(viewEngineEvents.replaceZoneParameters, handleReplaceZoneParametersEvent);
      piletApi.off(viewEngineEvents.deleteZone, handleDeleteZoneEvent);
    };
  }, [piletApi, handleCreateBlockEvent, handleReplaceBlockParametersEvent, handleDeleteBlockEvent, handleCreateZoneEvent, handleReplaceZoneParametersEvent, handleDeleteZoneEvent]);
}